import React from 'react';
import classes from "./BannerCard.module.css";

export default function BannerCard({data}) {
  return (
    <div className={classes.cardDiv}>
      <p className={`f-20 fw-600 ${classes.heading}`}>{data?.title}</p>
      <p className="f-16 fw-400">{data?.detail}</p>
    </div>
  )
}
